// extracted by mini-css-extract-plugin
export default {"kpis":"Kpis_kpis__U4tlu"};